import React, { useMemo, Fragment } from 'react'
import PropTypes from 'prop-types'
import CommonIcons from 'frontend/components/common-icons'
import Price from './price'

export default function Body (
  {
    timeSlot: { time, status, room }, matchedCartGame, pastTime = false,
    priceProps = {}
  }
) {
  if (status === 'available') {
    const formattedTime =
      useMemo(() => time.format(room.online ? 'h:mm a z' : 'h:mm a'), [time, room])

    return (
      <Fragment>
        <div className="time">{formattedTime}</div>
        {matchedCartGame
          ? (<div className="status">CHECKOUT</div>)
          : (<Fragment><Price {...priceProps} /></Fragment>)}
      </Fragment>
    )
  }

  return (
    <Fragment>
      <div className="status">
        {status}
        {pastTime
          ? (<CommonIcons item="common-eye-slash-r" className="icon" />)
          : (<CommonIcons item="common-eye-r" className="icon" />)}
      </div>
      <div className="time">other options</div>
    </Fragment>
  )
}

Body.propTypes = {
  timeSlot: PropTypes.object.isRequired,
  matchedCartGame: PropTypes.object,
  priceProps: PropTypes.object,
  pastTime: PropTypes.bool
}
